module.exports = __webpack_public_path__ + "img/card8.6f39231c.jpg";